import script from "./nav-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./nav-bar.vue?vue&type=script&setup=true&lang=js"

import "./nav-bar.vue?vue&type=style&index=0&id=8794ec58&lang=less&scoped=true"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8794ec58"]])

export default __exports__